/** CRM-4 ComplianceAuditPage — audit log esteso */
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Loader2, Activity, Download } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const EVENT_TYPES = [
  "", "gdpr_export", "gdpr_erase", "mandato_generato", "mandato_firmato",
  "consent_concesso", "consent_revocato", "payment_link_created",
  "whatsapp_sent_mocked", "document_downloaded", "policy_modified",
  "session_revoked", "session_revoke_all", "device_new_trusted",
];

export default function ComplianceAuditPage() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [tipoF, setTipoF] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.set("page", String(page));
      if (tipoF) params.set("tipo_evento", tipoF);
      const r = await axios.get(`${API}/api/admin/compliance/audit-log?${params.toString()}`, { withCredentials: true });
      setItems(r.data.items || []); setTotal(r.data.total || 0);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [tipoF, page]);
  useEffect(() => { load(); }, [load]);

  const exportCsv = () => {
    const rows = [
      ["ts", "operazione", "actor", "customer_id", "details"].join(","),
      ...items.map(it => [
        it.ts || it.timestamp || "",
        it.operazione || it.event || "",
        it.actor_email || "",
        it.customer_id || "",
        JSON.stringify(it).replace(/,/g, ";").slice(0, 200),
      ].join(","))
    ].join("\n");
    const blob = new Blob([rows], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `audit_log_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
  };

  return (
    <div className="p-4 md:p-6" data-testid="compliance-audit-page">
      <div className="flex justify-between mb-4">
        <h2 className="text-xl font-semibold flex items-center gap-2"><Activity className="w-5 h-5" /> Audit Log ({total})</h2>
        <button onClick={exportCsv} className="px-3 py-2 text-sm bg-zinc-100 rounded flex items-center gap-1" data-testid="audit-export-csv">
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>
      <select value={tipoF} onChange={(e) => { setPage(1); setTipoF(e.target.value); }}
        className="mb-3 px-2 py-2 text-sm rounded border border-zinc-200" data-testid="audit-filter-tipo">
        <option value="">Tutti gli eventi</option>
        {EVENT_TYPES.filter(Boolean).map(t => <option key={t} value={t}>{t}</option>)}
      </select>
      {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> :
       items.length === 0 ? <p className="text-zinc-400 italic text-center py-6">Nessun evento</p> :
        <div className="space-y-1">
          {items.map((it) => (
            <div key={it.id} className="border border-zinc-100 rounded p-2 text-xs" data-testid={`audit-${it.id}`}>
              <p className="flex justify-between">
                <span className="font-mono text-emerald-700">{it.operazione || it.event}</span>
                <span className="text-zinc-400">{(it.ts || it.timestamp || "").slice(0, 16).replace("T", " ")}</span>
              </p>
              <p className="text-zinc-600">{it.actor_email || "system"}{it.customer_id ? ` · customer ${it.customer_id}` : ""}</p>
            </div>
          ))}
        </div>}
    </div>
  );
}
